import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_radio = _resolveComponent("ion-radio")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_radio_group = _resolveComponent("ion-radio-group")!

  return (_openBlock(), _createBlock(_component_ion_radio_group, {
    "aira-label": "recipe-name",
    mode: "md",
    value: _ctx.localModelValue
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sorted, (option) => {
        return (_openBlock(), _createBlock(_component_ion_item, {
          "aria-label": _ctx.labelDisplay(option),
          key: option[_ctx.keyName],
          button: "",
          lines: "none",
          class: _normalizeClass({ dense: _ctx.dense, altLabel: _ctx.useAltLabel(option) }),
          onClick: ($event: any) => (_ctx.radioClick(option)),
          detail: option.isCustomPizza
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              innerHTML: _ctx.labelDisplay(option),
              class: "ion-text-capitalize interstate-bold ion-text-wrap"
            }, null, 8, _hoisted_1),
            _createVNode(_component_ion_radio, {
              "aria-labelledby": _ctx.labelDisplay(option),
              slot: "start",
              value: option,
              "data-cy": 'radio-' + _ctx.createSlug(option[_ctx.keyName]),
              class: _normalizeClass({ left: _ctx.left, right: _ctx.right })
            }, null, 8, ["aria-labelledby", "value", "data-cy", "class"])
          ]),
          _: 2
        }, 1032, ["aria-label", "class", "onClick", "detail"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["value"]))
}